(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["icg-cart-upsell"] && !Shopify.designMode) return;
  try {
    // One delegated handler for the whole page: the drawer is re-rendered on every cart change, so
  // handlers attached to its buttons would be lost. Only buttons inside the drawer upsell are handled.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-icg-drawer-upsell-add]');
    if (!button || button.disabled) return;

    const root = button.closest('[data-icg-drawer-upsell]');
    const errorEl = root ? root.querySelector('[data-icg-drawer-upsell-error]') : null;
    const label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding';
    if (errorEl) errorEl.hidden = true;

    const fail = (message) => {
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
      button.disabled = false;
      button.textContent = label;
    };

    try {
      const { CartAddEvent, CartErrorEvent } = await import('@theme/events');
      const sectionIds = [...document.querySelectorAll('cart-items-component')]
        .map((item) => item.dataset.sectionId)
        .filter(Boolean);

      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(button.dataset.variantId),
          quantity: 1,
          sections: sectionIds.join(','),
        }),
      });
      const data = await response.json();

      if (data.status) {
        fail(data.description || data.message || 'Sorry, that item could not be added.');
        button.dispatchEvent(new CartErrorEvent('icg-drawer-upsell', data.message, data.description, data.errors));
        return;
      }

      const cart = await (await fetch('/cart.js')).json();
      button.dispatchEvent(
        new CartAddEvent(cart, String(button.dataset.variantId), {
          source: 'icg-drawer-upsell',
          itemCount: 1,
          productId: button.dataset.productId,
          sections: data.sections,
        })
      );

      const item = button.closest('[data-icg-drawer-upsell-item]');
      if (item) item.hidden = true;
    } catch (error) {
      console.error(error);
      fail('Sorry, something went wrong. Please try again.');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
